import React, {useState, useContext, useRef, useEffect} from 'react';
import {useHistory} from "react-router-dom";
import {LoaderContext} from "../../../../context/LoaderContext.jsx";
import {getSchedulazioneByIdApi} from "../../../../services/SchedulazioniServices";

export const useModificaSchedulazione = ({idSchedulazione}) => {

    const loader = useRef(useContext(LoaderContext));

    const [schedulazione, setSchedulazione] = useState(null);

    const formikRef = useRef();
    const history = useHistory();

    async function getSchedulazioneById() {
        loader.current.startChiamata();
        const response = await getSchedulazioneByIdApi(idSchedulazione);
        setSchedulazione(response.data.data);
        loader.current.endChiamata();
    }

    useEffect(() => {
        if (idSchedulazione && idSchedulazione !== '') {
            getSchedulazioneById();
        }
    }, [idSchedulazione]);

    const getBottoniSx = () =>
        <button type="button" id="back" name="back"
                className="btn btn-card"
                onClick={() => {
                    history.goBack();
                }}>
            <i className="fas fa-angle-left"/>
        </button>

    const getBottoniDx = () =>
        <button type="button" id="salva" name="salva"
                className="btn btn-card"
                onClick={() => {
                    if (formikRef.current) {
                        formikRef.current.handleSubmit()
                    }
                }}>
            <i className="fas fa-save"/> <span className={'cmms-display-mobile'}>Salva</span>
        </button>

    const title = idSchedulazione ? 'Modifica Schedulazione' : 'Inserisci Schedulazione';

    return {
        getBottoniSx,
        getBottoniDx,
        title,
        schedulazione,
        formikRef,
    };
};
